<div class="edit-dialog">
  <div class="table-header d-flex flex-row justify-content-between align-items-center h-20">
    <h2 class="m-4">
      {{ editMode ? 'Edition' : 'Création' }} d'une ville
    </h2>
  </div>
  <mat-dialog-content>
    <form *ngIf="editForm" class="mt-2 w-100 bordered corners" name="editForm" novalidate [formGroup]="editForm"
      (ngSubmit)="onSubmitForm()">
      <div class="row w-100">
        <div class="col-sm-4" *ngIf="editMode">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>ID</mat-label>
            <input required matInput type="text" formControlName="id" readonly [disabled]="true" class="text-muted" />
          </mat-form-field>
        </div>

        <div [ngClass]="{ 'col-sm-4': editMode, 'col-sm-6': !editMode }">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Nom</mat-label>
            <input required matInput type="text" formControlName="name" />
          </mat-form-field>
        </div>

        <div [ngClass]="{ 'col-sm-4': editMode, 'col-sm-6': !editMode }">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Pays</mat-label>
            <mat-select formControlName="country">
              <mat-option [value]="null"></mat-option>
              <mat-option [value]="country.id" *ngFor="let country of sortByName(countries)">{{ country.name }} • {{
                country.codeCountry }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-2 justify-content-center">
        <div class="col-sm-2">
          <button mat-raised-button class="admin" [disabled]="editForm.invalid || isSaving || !editForm.dirty">
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>
    </form>
    <div class="row w-100 mt-3">
      <div class="col-12 d-flex align-items-center flex-wrap gap-1">
        <strong class="me-2">Destinations</strong>
        <mat-chip-set>
          <mat-chip
            *ngFor="let id of selectedDestinationIds"
            [removable]="true"
            (removed)="removeDestination(id)">
            {{ getDestinationName(id) }}
            <button matChipRemove><mat-icon>cancel</mat-icon></button>
          </mat-chip>
        </mat-chip-set>
      </div>
      <div class="col-sm-6 mt-2">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Ajouter une destination</mat-label>
          <mat-select [formControl]="destinationSelectControl" (selectionChange)="addDestination($event.value)">
            <mat-option [value]="null"></mat-option>
            <mat-option *ngFor="let dest of sortByName(getAvailableDestinations())" [value]="dest.id">
              {{ dest.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
</div>